import React, { useState } from 'react';
import logo from './img/logo.png';
import './App.css';
import {Carousel} from 'primereact/carousel';
import products from './data';
import  './Carousel.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import { Dialog } from 'primereact/dialog';


 

function App() {
  const responsiveOptions = [
    {
      breakpoint: '480px',
      numVisible: 1,
      numScroll: 1
  },
  {
    breakpoint: '600px',
    numVisible: 1,
    numScroll: 1
  },
    {
      breakpoint: '1024px',
      numVisible: 1,
      numScroll: 1
  },
  
  
  ];
  
  function carouselClick (img:any) {
    setPopImage(img);
    setDialogVisible(true);
    
  }
  function showImg(img:any){
    return(
      <Dialog style={{width:'100%'}} visible={dialogVisible} onHide={()=>setDialogVisible(false)}><div style={{textAlign:'center'}}><img src={img}  className="product-image"  /></div></Dialog>
    )
  }
  const productTemplate = (product:any) => {
    return (
        <div className="product-item">
            <div className="product-item-content" >
                <div className="p-mb-3">
                    <button onClick={()=>carouselClick(product.image)}><img src={product.image}  className="product-image"  /></button>
                    
                </div>
                
            </div>
        </div>
    );
  }
  const [dialogVisible,setDialogVisible] = useState(false);
  const [popImage,setPopImage] = useState('');
  return (
    <div className="App">
      <div >
        <div ><img style={{width:'100%'}} src={logo} /></div>
       <div className="carousel-demo">
      <Carousel value={products} itemTemplate={productTemplate} numVisible={1} numScroll={1} responsiveOptions={responsiveOptions}></Carousel>
      </div>
      </div>
      {showImg(popImage)}
    </div>
  );
}

export default App;
